export const USER_PERMISSIONS = {
  STAFF: "STAFF",
  TO_EVAL: "TO_EVAL",
  SETTING: "SETTING",
  LIST_ALL_EVALUATIONS: "LIST_ALL_EVALUATIONS",
  CALIBRATION: "CALIBRATION",
  VIEW_FINAL_POINT: "VIEW_FINAL_POINT",
  ORGANIGRAMA: "ORGANIGRAMA",
  VIEW_REPORT: "VIEW_REPORT",
};
